import type { StatusMapping } from "@/shared/components";
import type { ResignationStatus } from "../types";
import { RESIGNATION_STATUS_MAP } from "./statuses";

const colorToClasses: Record<string, { bg: string; dot: string }> = {
  notice: { bg: "bg-orange-500/40", dot: "bg-orange-500" },
  positive: { bg: "bg-green-500/40", dot: "bg-green-500" },
  negative: { bg: "bg-red-500/40", dot: "bg-red-500" },
  info: { bg: "bg-blue-500/40", dot: "bg-blue-500" },
};

export const RESIGNATION_STATUS_MAPPING: Record<string, StatusMapping> = Object.keys(RESIGNATION_STATUS_MAP).reduce(
  (acc, key) => {
    const status = key as ResignationStatus;
    const statusInfo = RESIGNATION_STATUS_MAP[status];
    const colors = colorToClasses[statusInfo.color] || colorToClasses.info;

    acc[status] = {
      bg: colors.bg,
      dot: colors.dot,
      titleKey: statusInfo.label,
      namespace: "ContractsPage",
    };

    return acc;
  },
  {} as Record<string, StatusMapping>,
);

